
import Logger from "./shared/logger";
const LOGGER = new Logger(__filename);



/**
 * @fileOverview
 * Wrapper um auf Kontext-Informationen der Umgebung zuzugreifen. Um auf die
 * Auth-Infos zuzugreifen sollte man den Weg über den Store gehen (Module: module-auth).
 * 
 * Das Objekt window.mc muss die baseUrl und weitere Informationen enthalten,
 * existiert das Objekt nicht, so werden Standard-Infos für die Entwicklungszeit
 * zurückgegeben.
 */

const NO_URL = "NO URL GIVEN!!";

/**
 * Das context Object
 * */
const context = (function () {
    if (typeof window !== "undefined" && window.mc) { 
        return window.mc;
    }
    LOGGER.error("object with context information not found");
    return {
        baseUrl: NO_URL,
        logoutUrl: NO_URL,
        userName: null,
        isAdmin: true,
        isAuthor: true,
    };
}());
//export default context;
export { context, NO_URL };
